import { getFormattedDate } from "../../../../common/utils/helpers/getFormattedDate";

/**
 * Strips the UI-only `hasRemove` flag and formats birthdate as a local
 * `yyyy-MM-dd` string (avoids UTC day-shift from Date.toISOString()).
 */
export function mapSbbPassengersForApi(passengerList: Array<any>) {
  return (Array.isArray(passengerList) ? passengerList : []).map(
    ({ hasRemove: _hasRemove, birthdate, ...passenger }) => ({
      ...passenger,
      birthdate: getFormattedDate(birthdate)
    })
  );
}
